
import { useToast } from '@/hooks/use-toast';
import { createCheckoutSession, accessCustomerPortal, checkSubscriptionStatus } from '@/services/stripe';

export function useSubscriptionFunctions() {
  const { toast } = useToast();

  const handleCheckout = async (plan: string) => {
    try {
      toast({
        title: "Initiiere Checkout...",
        description: "Bereite dein Abonnement-Checkout vor",
      });
      
      const data = await createCheckoutSession(plan);
      
      // Check if data contains URL (could be direct URL or in data.url)
      const checkoutUrl = data.url || (typeof data === 'string' ? data : null);
      
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else if (data.redirectUrl) {
        // For free plans, we might get a redirectUrl instead
        window.location.href = data.redirectUrl;
      } else {
        throw new Error('No redirect URL received');
      }
    } catch (error: any) {
      toast({
        title: "Checkout-Fehler",
        description: "Es gab einen Fehler beim Starten des Checkout-Prozesses",
        variant: "destructive",
      });
      console.error(error);
    }
  };

  const handleManageSubscription = async () => {
    try {
      toast({
        title: "Öffne Kundenportal...",
        description: "Du wirst zum Abonnementverwaltungsportal weitergeleitet",
      });
      
      const data = await accessCustomerPortal();
      
      if (!data.url) {
        throw new Error('No customer portal URL received');
      }
      
      window.location.href = data.url;
    } catch (error: any) {
      toast({
        title: "Portal-Fehler",
        description: "Es gab einen Fehler beim Öffnen des Abonnementverwaltungsportals",
        variant: "destructive",
      });
      console.error(error);
    }
  };

  return {
    handleCheckout,
    handleManageSubscription,
    checkSubscriptionStatus
  };
}
